import { api } from "./api";

export const GetEmployee = async (
  tenantemployeeid: number,
  employeenumber: string,
  tenantid: number,
  mallid: number,
  number: number,
  page: number
) => {
  try {
    const url = `/tenant/v1/gettenantemployee?tenantemployeeid=${tenantemployeeid}&employeenumber=${employeenumber}&mallid=${mallid}&tenantid=${tenantid}&number=${number}&page=${page}`;
    const response = await api.get(url);
    if (response.status === 200) return response.data;
  } catch (error) {
    console.log(error);
  }
};

export const SaveEmployee = async (data: Record<string, unknown>) => {
  try {
    const url = `/tenant/v1/savetenantemployee`;
    const response = await api.post(url, data);
    if (response.status === 200) return response.data;
  } catch (error) {
    console.log(error);
  }
};

export const SaveAccessCard = async (data: Record<string, unknown>) => {
  try {
    const url = `/api/accesscard/v1/save`;
    const response = await api.post(url, data);
    if (response.status === 200) return response.data;
  } catch (error) {
    console.log(error);
  }
};

export const DeleteEmployee = async (tenantemployeeid: number) => {
  try {
    const url = `/tenant/auth/deletetenantemployee/${tenantemployeeid}`;
    const response = await api.delete(url);
    if (response.status === 200) return response.data;
  } catch (error) {
    console.log(error);
  }
};